var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"volunteer_amount"},[_c('i',{staticClass:"hand-icon"}),_vm._v("累计帮助患者筹得"),_c('span',{staticClass:"strong"},[_vm._v(" "+_vm._s(_vm._f("formatAmount")(_vm.totalAmount))+" ")]),_vm._v("元 ")])}
var staticRenderFns = []

export { render, staticRenderFns }